import { render, staticRenderFns } from "./boardGalleryDetailPage.vue?vue&type=template&id=1bc58afa&scoped=true&"
import script from "./boardGalleryDetailPage.vue?vue&type=script&lang=js&"
export * from "./boardGalleryDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./boardGalleryDetailPage.vue?vue&type=style&index=0&id=1bc58afa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc58afa",
  null
  
)

export default component.exports